import {
  CssBaseline,
  ThemeProvider as MuiThemeProvider,
  createTheme,
} from "@mui/material";

const appTheme = createTheme({
  palette: {
    primary: {
      main: "rgba(14, 50, 149, 1)",
      50: "rgba(232, 237, 253, 1)",
      100: "rgba(190, 205, 249, 1)",
      150: "rgba(106, 142, 241, 1)",
      200: "rgba(22, 78, 233, 1)",
      300: "rgba(18, 64, 191, 1)",
      400: "rgba(14, 50, 149, 1)",
      500: "rgba(22, 42, 120, 1)",
      600: "rgba(24, 34, 93, 1)",
      700: "rgba(22, 26, 67, 1)",
      800: "rgba(19, 19, 42, 1)",
      900: "rgba(2, 8, 23, 1)",
    },
    secondary: {
      main: "rgba(82, 105, 173, 1)",
      50: "rgba(242, 243, 249, 1)",
      100: "rgba(216, 220, 237, 1)",
      150: "rgba(191, 198, 225, 1)",
      200: "rgba(175, 186, 217, 1)",
      300: "rgba(144, 159, 203, 1)",
      400: "rgba(114, 133, 188, 1)",
      500: "rgba(82, 105, 173, 1)",
      600: "rgba(67, 86, 142, 1)",
      700: "rgba(52, 67, 111, 1)",
      800: "rgba(38, 48, 80, 1)",
      900: "rgba(23, 29, 49, 1)",
    },
    neutral: {
      50: "rgba(247, 247, 248, 1)",
      100: "rgba(230, 230, 234, 1)",
      150: "rgba(216, 216, 222, 1)",
      200: "rgba(192, 192, 201, 1)",
      300: "rgba(165, 165, 178, 1)",
      400: "rgba(142, 142, 159, 1)",
      500: "rgba(117, 117, 138, 1)",
      600: "rgba(96, 96, 113, 1)",
      700: "rgba(75, 75, 88, 1)",
      800: "rgba(54, 54, 63, 1)",
      900: "rgba(33, 33, 39, 1)",
      950: "rgba(12, 12, 14, 1)",
    },
    tertiary: {
      main: "rgba(204, 212, 235, 1)",
      400: "rgba(204, 212, 235, 1)",
    },
    logoblanco: "rgba(254, 254, 255, 1)",
    areaadministracion: {
      200: "rgba(238, 236, 248, 1)",
      300: "rgba(206, 203, 236, 1)",
      400: "rgba(175, 169, 223, 1)",
      500: "rgba(145, 137, 211, 1)",
      600: "rgba(112, 102, 199, 1)",
      700: "rgba(83, 69, 186, 1)",
      800: "rgba(68, 56, 153, 1)",
    },
    areabarra: {
      200: "rgba(162, 218, 231, 1)",
      300: "rgba(89, 190, 212, 1)",
      400: "rgba(52, 175, 203, 1)",
      500: "rgba(47, 160, 185, 1)",
      600: "rgba(33, 112, 130, 1)",
      700: "rgba(24, 81, 93, 1)",
      800: "rgba(15, 49, 57, 1)",
    },
    areacocina: {
      200: "rgba(245, 233, 194, 1)",
      300: "rgba(238, 219, 155, 1)",
      400: "rgba(231, 204, 115, 1)",
      500: "rgba(225, 190, 76, 1)",
      600: "rgba(218, 176, 37, 1)",
      700: "rgba(179, 144, 30, 1)",
      800: "rgba(140, 112, 24, 1)",
    },
    arealimpieza: {
      200: "rgba(223, 231, 162, 1)",
      300: "rgba(198, 212, 89, 1)",
      400: "rgba(185, 203, 52, 1)",
      500: "rgba(169, 185, 47, 1)",
      600: "rgba(119, 130, 33, 1)",
      700: "rgba(85, 93, 24, 1)",
      800: "rgba(52, 57, 15, 1)",
    },
    areasalon: {
      200: "rgba(238, 200, 200, 1)",
      300: "rgba(227, 165, 165, 1)",
      400: "rgba(206, 95, 95, 1)",
      500: "rgba(195, 60, 60, 1)",
      600: "rgba(160, 49, 49, 1)",
      700: "rgba(125, 38, 38, 1)",
      800: "rgba(90, 28, 28, 1)",
    },
    horarioasistencia: {
      200: "rgba(243, 244, 240, 1)",
      300: "rgba(198, 206, 186, 1)",
      400: "rgba(172, 184, 155, 1)",
      500: "rgba(153, 168, 133, 1)",
      600: "rgba(131, 149, 106, 1)",
    },
    horarioausencia: {
      200: "rgba(238, 200, 200, 1)",
      300: "rgba(227, 165, 165, 1)",
      400: "rgba(217, 132, 132, 1)",
      500: "rgba(206, 95, 95, 1)",
      600: "rgba(195, 60, 60, 1)",
    },
    horarioferiado: {
      200: "rgba(135, 212, 181, 1)",
      300: "rgba(101, 200, 160, 1)",
      400: "rgba(61, 168, 125, 1)",
      500: "rgba(43, 120, 89, 1)",
      600: "rgba(31, 86, 64, 1)",
    },
    horariofranco: {
      200: "rgba(240, 239, 245, 1)",
      300: "rgba(214, 211, 228, 1)",
      400: "rgba(196, 191, 216, 1)",
      500: "rgba(162, 154, 193, 1)",
      600: "rgba(135, 125, 176, 1)",
    },
    horariotardanza: {
      200: "rgba(239, 233, 200, 1)",
      300: "rgba(228, 219, 165, 1)",
      400: "rgba(221, 209, 141, 1)",
      500: "rgba(207, 190, 94, 1)",
      600: "rgba(196, 176, 59, 1)",
    },
    horarioturno: {
      200: "rgba(169, 197, 223, 1)",
      300: "rgba(136, 175, 211, 1)",
      400: "rgba(109, 157, 201, 1)",
      500: "rgba(69, 129, 186, 1)",
      600: "rgba(56, 106, 153, 1)",
    },
    liquidacionanualhora: {
      200: "rgba(235, 162, 158, 1)",
      300: "rgba(227, 125, 120, 1)",
      400: "rgba(216, 74, 67, 1)",
      500: "rgba(212, 52, 43, 1)",
      600: "rgba(174, 42, 36, 1)",
    },
    liquidacionanualmensual: {
      200: "rgba(196, 243, 222, 1)",
      300: "rgba(158, 235, 200, 1)",
      400: "rgba(67, 216, 149, 1)",
      500: "rgba(36, 174, 111, 1)",
      600: "rgba(28, 135, 87, 1)",
    },
    liquidacionanualtotal: {
      200: "rgba(158, 192, 235, 1)",
      300: "rgba(120, 168, 227, 1)",
      400: "rgba(67, 134, 216, 1)",
      500: "rgba(43, 119, 212, 1)",
      600: "rgba(36, 98, 174, 1)",
    },
    liquidacioncomparacion: {
      opcion1: "rgba(222, 116, 102, 1)",
      opcion2: "rgba(102, 148, 222, 1)",
      opcion3: "rgba(102, 222, 176, 1)",
    },
    prioridad: {
      alta: "rgba(218, 77, 58, 1)",
      media: "rgba(218, 199, 58, 1)",
      baja: "rgba(85, 188, 107, 1)",
    },
    logocarpeta: {
      1: "rgba(196, 196, 206, 1)",
      2: "rgba(165, 165, 178, 1)",
    },
    logo3dsabitasksfondo: "rgba(14, 50, 149, 1)",
  },
  typography: {
    fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
    h1: {
      fontFamily: "'Inter', Helvetica, Arial, sans-serif",
      fontSize: "28px",
      fontWeight: 500,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    h2: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "22px",
      fontWeight: 600,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    h3: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "18px",
      fontWeight: 400,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    subtitle1: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "18px",
      fontWeight: 600,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    subtitle2: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "16px",
      fontWeight: 600,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    body1: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "16px",
      fontWeight: 400,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    body2: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "14px",
      fontWeight: 400,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    caption: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "15px",
      fontWeight: 400,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    button: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "16px",
      fontWeight: 700,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
      textTransform: "none",
    },
    overline: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "12px",
      fontWeight: 400,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    webH2: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "22px",
      fontWeight: 600,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    webH3Subtitulo: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "18px",
      fontWeight: 600,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    webGeneralTitulo: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "16px",
      fontWeight: 700,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    webGeneralSubtitulo: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "16px",
      fontWeight: 600,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    webGeneralGeneral: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "16px",
      fontWeight: 400,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    webPlaceholder: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "16px",
      fontWeight: 300,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    webBajada: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "15px",
      fontWeight: 400,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    bodyCursiva: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "16px",
      fontWeight: 400,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "italic",
    },
    h3Titulo: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "18px",
      fontWeight: 700,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    bodyTitulo: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "16px",
      fontWeight: 700,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    bodySubtitulo: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "16px",
      fontWeight: 600,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
    tagsFiltros: {
      fontFamily: "'Open Sans', Helvetica, Arial, sans-serif",
      fontSize: "12px",
      fontWeight: 400,
      letterSpacing: "0px",
      lineHeight: "normal",
      fontStyle: "normal",
    },
  },
  shadows: [
    "none",
    "0px 0px 10px 0px rgba(165, 165, 178, 1)",
    "0px 0px 8px 0px rgba(96, 96, 113, 1)",
    "0px 0px 4px 0px rgba(117, 117, 138, 1)",
    "0px 0px 4px 0px rgba(192, 192, 201, 1)",
    "0px 0px 6px 0px rgba(165, 165, 178, 1)",
    "0px 0px 6px 0px rgba(142, 142, 159, 0.6)",
    "-2px 3px 6px 0px rgba(54, 54, 63, 0.4)",
    "0px 5px 5px -3px rgba(0,0,0,0.2),0px 8px 10px 1px rgba(0,0,0,0.14),0px 3px 14px 2px rgba(0,0,0,0.12)",
    "0px 5px 6px -3px rgba(0,0,0,0.2),0px 9px 12px 1px rgba(0,0,0,0.14),0px 3px 16px 2px rgba(0,0,0,0.12)",
    "0px 6px 6px -3px rgba(0,0,0,0.2),0px 10px 14px 1px rgba(0,0,0,0.14),0px 4px 18px 3px rgba(0,0,0,0.12)",
    "0px 6px 7px -4px rgba(0,0,0,0.2),0px 11px 15px 1px rgba(0,0,0,0.14),0px 4px 20px 3px rgba(0,0,0,0.12)",
    "0px 7px 8px -4px rgba(0,0,0,0.2),0px 12px 17px 2px rgba(0,0,0,0.14),0px 5px 22px 4px rgba(0,0,0,0.12)",
    "0px 7px 8px -4px rgba(0,0,0,0.2),0px 13px 19px 2px rgba(0,0,0,0.14),0px 5px 24px 4px rgba(0,0,0,0.12)",
    "0px 7px 9px -4px rgba(0,0,0,0.2),0px 14px 21px 2px rgba(0,0,0,0.14),0px 5px 26px 4px rgba(0,0,0,0.12)",
    "0px 8px 9px -5px rgba(0,0,0,0.2),0px 15px 22px 2px rgba(0,0,0,0.14),0px 6px 28px 5px rgba(0,0,0,0.12)",
    "0px 8px 10px -5px rgba(0,0,0,0.2),0px 16px 24px 2px rgba(0,0,0,0.14),0px 6px 30px 5px rgba(0,0,0,0.12)",
    "0px 8px 11px -5px rgba(0,0,0,0.2),0px 17px 26px 2px rgba(0,0,0,0.14),0px 6px 32px 5px rgba(0,0,0,0.12)",
    "0px 9px 11px -5px rgba(0,0,0,0.2),0px 18px 28px 2px rgba(0,0,0,0.14),0px 7px 34px 6px rgba(0,0,0,0.12)",
    "0px 9px 12px -6px rgba(0,0,0,0.2),0px 19px 29px 2px rgba(0,0,0,0.14),0px 7px 36px 6px rgba(0,0,0,0.12)",
    "0px 10px 13px -6px rgba(0,0,0,0.2),0px 20px 31px 3px rgba(0,0,0,0.14),0px 8px 38px 7px rgba(0,0,0,0.12)",
    "0px 10px 13px -6px rgba(0,0,0,0.2),0px 21px 33px 3px rgba(0,0,0,0.14),0px 8px 40px 7px rgba(0,0,0,0.12)",
    "0px 10px 14px -6px rgba(0,0,0,0.2),0px 22px 35px 3px rgba(0,0,0,0.14),0px 8px 42px 7px rgba(0,0,0,0.12)",
    "0px 11px 14px -7px rgba(0,0,0,0.2),0px 23px 36px 3px rgba(0,0,0,0.14),0px 9px 44px 8px rgba(0,0,0,0.12)",
    "0px 11px 15px -7px rgba(0,0,0,0.2),0px 24px 38px 3px rgba(0,0,0,0.14),0px 9px 46px 8px rgba(0,0,0,0.12)",
  ],
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: "none",
          borderRadius: "33px",
        },
      },
    },
    MuiCssBaseline: {
      styleOverrides: {
        body: {
          backgroundColor: "rgba(230, 230, 234, 1)",
        },
      },
    },
  },
});

export const ThemeProvider = ({ children }) => {
  return (
    <MuiThemeProvider theme={appTheme}>
      <CssBaseline />
      {children}
    </MuiThemeProvider>
  );
};
